import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { enrutador } from './enrutador'
import './estilos/tokens.css'
import './estilos/global.css'

const clienteDeConsultas = new QueryClient({
  defaultOptions: {
    queries: {
      // Un catálogo de 34 espacios no cambia entre pestañas: no hay razón para
      // recargarlo cada vez que la ventana recupera el foco.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
})

const contenedor = document.getElementById('raiz')
if (contenedor === null) {
  throw new Error('No se encontró el elemento #raiz en index.html.')
}

createRoot(contenedor).render(
  <StrictMode>
    <QueryClientProvider client={clienteDeConsultas}>
      <RouterProvider router={enrutador} />
    </QueryClientProvider>
  </StrictMode>,
)
